import { DeleteAccountModal } from './DeleteAccountModal';

export const FacebookIntegrationModals = () => (
  <>
    <DeleteAccountModal />
  </>
);
